module.exports = __webpack_public_path__ + "static/bnr2.a7fead93.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/bnr2.jpg
// module id = 615
// module chunks = 35783957827783